// src/features/dashboard/pages/DashboardPage.jsx
import React from 'react';
import {
  Box,
} from '@mui/material';
import OverdueTasksWarning from '../components/OverdueTasksWarning';
import DashboardHeader from '../components/DashboardHeader';
import DashboardStatsCards from '../components/DashboardStatsCard';
import TaskQueueDataGrid from '../components/TaskQueueDataGrid';
import { useTranslation } from 'react-i18next';

export default function DashboardPage() {
  const { t } = useTranslation(["common", "tasks"]);

  return (
    <Box>
      <Box>
        <DashboardHeader />
        <OverdueTasksWarning />
        <DashboardStatsCards />
        <TaskQueueDataGrid />
      </Box>
    </Box>
  );
}